const navigationStylesCommons = {
    height: 'auto',
    width: 'auto',
    pos: 'relative',
    left: 0,
    right: 0,
    top: 0,
    mt: 0,
    p: 'spacing.2',
    _after: {
        display: 'none',
    },
}

const productsSwiper = {
    ProductsSwiper: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
            },
            titleWrapper: {
                w: '100%',
                textAlign: 'center',
                pb: {base: 'spacing.2', xl: 'spacing.5'},
            },
            title: {
                textStyle: 'displayMd',
            },
            navigation: {
                pos: 'relative',
                justifyContent: 'flex-end',
                gap: 'spacing.2',
                pb: 'spacing.4',
            },
            navigationPrev: {
                ...navigationStylesCommons,
            },
            navigationNext: {
                ...navigationStylesCommons,
            },
            swiper: {},
        }),
    },
}

export default productsSwiper
